module.exports = __webpack_public_path__ + "img/altima_side.2016021a.png";